/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { IAppState } from 'src/store';
import { useComponentDidMount } from 'src/hooks';
import { View } from 'src/components/common';
import { filesAction } from 'src/redux/fileRedux';

const Content: React.FC<Props> = ({ isUploadDone, onSetUploadFileStatus, onResetUploadFile }) => {
  useEffect(() => {
    if (isUploadDone) {
      setTimeout(() => {
        onSetUploadFileStatus(false);
        onResetUploadFile();
      }, 3000);
    }
  }, [isUploadDone]);
  useComponentDidMount(() => {
    // handleGetContent();
  });

  return <View />;
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

const mapStateToProps = (state: IAppState) => ({
  isLoading: state.common.isLoading,
  isUploadDone: state.file.isUploadDone,
});

const mapDispatchToProps = {
  onSetUploadFileStatus: filesAction.setUploadDone,
  onResetUploadFile: filesAction.resetUploadFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Content);
